export default "__VITE_ASSET__5SIEmNdK__"